module.exports = __webpack_public_path__ + "static/media/edit_origin.05683053.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flavours/bubble/images/edit_origin.svg
// module id = 629
// module chunks = 0